import React from 'react';
import PropTypes from 'prop-types';
import Select from 'pre-fuse/components/Select';

const DomainGroupingTypeahead = ( {
    assignMode,
    createNewGroup,
    domainGroups,
    selectedGroupId,
    selectedGroupName,
    setSelectedGroupId,
} ) => {
    let options = domainGroups.map( ( group ) => {
        return { label: group.name, value: `${group.id}` };
    } );

    const createOption = ( newValue ) => {
        createNewGroup( newValue );
    };

    const changeHandler = ( selectedOption ) => {
        setSelectedGroupId( selectedOption ? selectedOption.value : null );
    };
    const maxInputLength = 50;

    const selectedValue = () => {
        return selectedGroupName ?
            { label: selectedGroupName, value: selectedGroupId } :
            null;
    };

    return <Select
        id="domain-grouping-typeahead"
        isCreatable={true}
        onCreateOption={createOption}
        onChange={changeHandler}
        maxLength={maxInputLength}
        value={
            selectedValue()
        }
        isClearable={!assignMode}
        options={options}
        placeholder="Enter group name or select an existing group"
        label="Group Name"
    />;
};

DomainGroupingTypeahead.propTypes = {
    assignMode: PropTypes.bool.isRequired,
    createNewGroup: PropTypes.func.isRequired,
    domainGroups: PropTypes.array.isRequired,
    selectedGroupId: PropTypes.number,
    selectedGroupName: PropTypes.string,
    setSelectedGroupId: PropTypes.func.isRequired,
};
export default DomainGroupingTypeahead;
